import React from 'react';

import "./Gate.scss";
import Background from '../../../Background/Background';

export const Gate = (props)=>{
    const {} = props;
    
    return (
        <div className="Gate">
        </div>
    )
}

